import React from 'react';
import { Link } from 'gatsby'
import classnames from 'classnames'

const Menu = ({ doc, menus }) => {

  const headings = Object.keys(menus)

  return (
    <ul className="p-sticky l-0 pb-10" style={{ top: '104px' }}>
      {headings.map((heading) => {
        return (
          <li>
            <ul>
              <h2 className="py-3 px-5 mt-2 c-secondary-500 fw-600 tt-uppercase ls-wide fs-1">{heading}</h2>
              {menus[heading].map((menu, key) => {
                const liClass = classnames('wc-transform px-5', {
                  'c-neutral-700': menu.name !== doc,
                  'hover:translate': menu.name !== doc,
                  'hover:c-tertiary-500': menu.name !== doc,
                  'hover:bg-secondary-100': menu.name === doc,
                  'bg-secondary-100 fw-600 br bw-4 bc-secondary-500': menu.name === doc,
                  'c-secondary-500': menu.name === doc
                })
                return (
                  <li className={liClass} key={menu.id}>
                    <Link
                      to={menu.route}
                      className="c-inherit py-2 d-block td-none fs-body c-pointer">
                      {key + 1}. {menu.name}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </li>
        )
      })}
    </ul>
  );
}

export default Menu;